export default __webpack_public_path__ + "static/media/11t.628ff912.jpg";